export default __webpack_public_path__ + "static/media/dashboard-lab.1d6421c9.svg";